// Copyright (c) 2024 Goffy. This file belongs to Goffy. All Rights Reserved.

import { getSharedBffWebSocket, LogEmitCommand } from './bffWebSocket';

type LogLevel = NonNullable<LogEmitCommand['level']>;

export const createAppLogger = (
  baseHttpUrl: string,
  token?: string | null,
  defaultAttributes?: Record<string, unknown>
) => {
  const client = getSharedBffWebSocket(baseHttpUrl);

  return (message: string, attributes?: Record<string, unknown>, level: LogLevel = 'info') => {
    try {
      const envName = process.env.EXPO_PUBLIC_APP_ENV ?? process.env.NODE_ENV ?? 'unknown';
      client.sendLog({
        message,
        level,
        attributes: { ...defaultAttributes, ...attributes, environment: envName },
      });
    } catch (err) {
      console.log('[appLogger][fallback]', message, attributes, err);
    }
  };
};
